module.exports = __webpack_public_path__ + "img/rpm-enrolled-icon.36b9801.png";